import { cn } from '@/lib/utils'
import {
  Delete,
  Download,
  Eye,
  EyeOff,
  LogIn,
  Pause,
  Pencil,
  PlusCircle,
  RefreshCw,
  Save,
  Send,
  Trash,
} from 'lucide-react'
export type IconName = keyof typeof ICONS
export type IconActionTypes =
  | 'edit'
  | 'delete'
  | 'add'
  | 'eye'
  | 'eyeOff'
  | 'clear'
  | 'save'
  | 'trash'
  | 'send'
  | 'login'
  | 'refreshCw'
  | 'download'
  | 'pause'
export const ICONS = ({
  className,
}: {
  className?: string
}): Record<IconActionTypes, React.ReactNode> => {
  return {
    edit: <Pencil className={cn('text-primary', className)} />,
    delete: <Trash className={cn('text-destructive', className)} />,
    add: <PlusCircle className={cn('text-primary', className)} />,
    eye: <Eye className={cn('text-primary', className)} />,
    eyeOff: <EyeOff className={cn('text-primary', className)} />,
    clear: <Delete className={cn('text-destructive', className)} />,
    save: <Save className={cn('text-primary', className)} />,
    trash: <Trash color="red" className={cn('text-destructive', className)} />,
    send: <Send className={cn('text-primary', className)} />,
    login: <LogIn className={cn('text-primary', className)} />,
    refreshCw: <RefreshCw className={cn('text-primary', className)} />,
    pause: <Pause className={cn('text-primary', className)} />,
    download: <Download className={cn('text-primary', className)} />,
  }
}
